module.exports = __webpack_public_path__ + "img/VM24_0997.5b4a643c.jpg";